import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
  OnDestroy
} from '@angular/core';
import {
  ModelStock,
  PccVehicle,
  StockVehicle,
  Vehicles
} from '../../model/vehicle.model';
import i18next from 'i18next';
import { OrderService } from 'src/app/core/services/order.service';
import { LoanReasons, LoanReasonsCarPool } from '../../model/loanRequest.enum';
import { Translate } from '../../utils/translate';
import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';
import { MatDialog } from '@angular/material/dialog';
import {
  FormGroup,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { CoreService } from 'src/app/core/services/core.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ControlErrors } from '../../utils/generateError';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { RequestType } from '../../model/requestType.enum';
import { MatSelectModule } from '@angular/material/select';
import {
  MatDatepicker,
  MatDatepickerModule
} from '@angular/material/datepicker';
import { UserService } from 'src/app/core/services/user.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { catchError, EMPTY, filter, firstValueFrom, map, Subscription, take, tap } from 'rxjs';
import { CONTEXT_TEMPLATE, environment } from 'src/environments/environment';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { User } from '../../model/user.model';
import { SharedModule } from '../../shared.module';
import { WebsocketService } from 'src/app/core/services/websocket.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { ConfiguratorBridgeService } from 'src/app/configurator-bridge.service';
interface ConfiguratorPayload {
  configurationProcess: string;
  seatCode: string;
}

function isValidPayload(params: Record<string, string> | ConfiguratorPayload): params is ConfiguratorPayload {
  return !!params['configurationProcess'] && !!params['seatCode'];
}
@Component({
  standalone: true,
  selector: 'app-car-configurator',
  templateUrl: './car-configurator.component.html',
  styleUrls: ['./car-configurator.component.scss'],
  imports: [
    CommonModule,
    SharedModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule
  ]
})

export class CarConfiguratorComponent implements OnInit, OnDestroy {
  @Input() vehicleInfoData?: PccVehicle;
  @Input() stockVehicleData?: StockVehicle;
  @Input() errorPcc = false;
  @Input() errorPccText?: string;
  @Input() removeData?: boolean;
  @Input() summaryRequest?: string;
  @Input() isDetail?: boolean;
  @Input() vehicle?: any;
  @Input() loanData?: any;
  @Input() isModify?: boolean;
  @Input() extraData: any;
  @Input() vehicleType!: string;
  @Input() isVip = false;

  @Output() carConfigInfoEmitter = new EventEmitter<PccVehicle>();
  @Output() configCodeEmitter = new EventEmitter<string>();
  @Output() pccErrorEmitter = new EventEmitter<boolean>();
  @Output() quotaEmitter = new EventEmitter<boolean>();
  @Output() getDetailEmitter = new EventEmitter();
  @Output() nextStep = new EventEmitter();
  @Output() maxQuotaEmit = new EventEmitter();
  @Output() showVehicleInfo = new EventEmitter<boolean>();

  private sub : Subscription = new Subscription();
  private context = '';


  url =
    environment.pccDomain +
    'seat-cc/configurator/LIVE/003/SIGEVA/es/car-selector;reference-data=';
  seatUrl = 'https://www.seat.es/configurador/w/model?wf=seat-es-es';
  cupraUrl = 'https://www.cupraofficial.es/configurador/w/model?wf=cupra-es';
  leasingUrl = environment.leasingPccUrl;
  vehicleCode = '';
  disableShowVehicle = true;
  user!: User;
  spinner = false;
  showInput = false;
  sustitutionVehicle?: Vehicles;
  numb?: number;
  totalDays?: number;
  totalQuota = 0;
  loanReasonsEnum = LoanReasons;
  loanReasonsKeys: (keyof typeof LoanReasons)[] = Object.keys(
    LoanReasons
  ) as (keyof typeof LoanReasons)[];
  loanReasonsCPEnum = LoanReasonsCarPool;
  loanReasonsCPKeys: (keyof typeof LoanReasonsCarPool)[] = Object.keys(
    LoanReasonsCarPool
  ) as (keyof typeof LoanReasonsCarPool)[];
  requestTypeEnum = RequestType;
  optionals = [];
  extensions = [];
  optionalCodes: string[] = [];
  extensionCodes: string[] = [];
  optionalDescriptions: string[] = [];
  extensionDescriptions: string[] = [];
  modelList?: ModelStock[];
  modelListSelected: string[] = [];
  educationalData: any;
  websocketSubscription: Subscription = new Subscription();
  isMacSafari = false;
  isIPad = false;

  maxQuota = 400;
  quota = 0;
  nis = '';

  pcc!: SafeResourceUrl;

  formattedDescriptions = '';
  formattedOptionals = '';
  isPhone = false;
  vehicleInfoVip = false;
  configCode = undefined;

  @ViewChild('deliveryPicker') deliveryPicker!: MatDatepicker<any>;
  @ViewChild('returnPicker') returnPicker!: MatDatepicker<any>;

  constructor(
    public fb: FormBuilder,
    private coreService: CoreService,
    private userService: UserService,
    private storageService: StorageService,
    private vehiclesService: VehiclesService,
    private controlErrors: ControlErrors,
    private orderService: OrderService,
    public translate: Translate,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private websocketService: WebsocketService,
    private utilsService: UtilsService,
    private bridge: ConfiguratorBridgeService// CRSMP-8547
  ) {}

  form: FormGroup = this.fb.group({
    vehicleCode: ''
  });
  formModify: FormGroup = this.fb.group({});
  formModifyVehicle: FormGroup = this.fb.group({});
  ngOnInit(): void {
    // CRSMP-8547 <<*********
this.sub = this.bridge.result$.pipe(
  take(1),
  tap(params => console.log('[IframeStep] params recibidos:', params)),
  filter(isValidPayload),
  tap(params => console.log('[IframeStep] payload válido:', params)),
  map(params => ({
    'configurationProcess': params['configurationProcess'],
    'seatCode': params['seatCode'],
      context: this.context
  })),
  tap(payload => console.log('[IframeStep] emitiendo payload:', payload)),
  catchError(err => {
    console.error('[IframeStep] error en el pipe:', err);
    return EMPTY; // traga el error sin romper la app
  })
).subscribe((payload) => this.nextStep.emit(payload)); 
// CRSMP-8547*************


    this.isPhone = this.utilsService.isPhone();
    this.isMacSafari =
      this.utilsService.isMacDesktop() && this.utilsService.isSafari();
    this.isIPad = this.utilsService.isIPad();
    this.educationalData = this.extraData
      ? this.extraData.educationalDataDTO
      : null;
    if (this.storageService.get('config')) {
      this.nis = this.storageService.get('config').nis;
    }
    //// CRSMP-8547 -->
    if (this.vehicleType === this.requestTypeEnum.leasing) {//LEASING
      
      this.context = 'dcc-es-seat-mg-le';

    } else {//ENDOWMENT
      this.context = 'dcc-es-seat-mg';
    }
    this.url = environment.pccDomain.replace(CONTEXT_TEMPLATE, this.context);
    this.pcc = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.coreService.getMaxQuota(this.vehicleType).subscribe({
      next: (maxQuota: number) => (
        (this.maxQuota = maxQuota),
        this.maxQuotaEmit.emit(maxQuota)
      )
    });
    //// CRSMP-8547 <--
    if (this.stockVehicleData && this.isModify) {
      this.vehiclesService.getStockModels().subscribe({
        next: (resp: ModelStock[]) => {
          this.modelList = resp;
          if (
            this.extraData?.requestType === this.requestTypeEnum.generalServices
          ) {
            this.markSelectedModels();
          }
        }
      });
    }
    this.setupWebSocket();
    this.initForm();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe(); // CRSMP-8547
    if (!this.isVip && !this.isDetail) {
      this.websocketService.disconnect();
      this.websocketSubscription.unsubscribe();
    }
  }

  changeModel(data: string) {
    const existElement = this.modelListSelected.find(
      (item: string) => item === data
    );
    if (existElement) {
      this.modelListSelected = this.modelListSelected.filter(
        (item: string) => item !== data
      );
    } else {
      this.modelListSelected.push(data);
    }
  }

  markSelectedModels(): void {
    const selectedModels = (this.stockVehicleData?.models || []).map((model) =>
      model.toUpperCase()
    );

    this.modelListSelected = [...selectedModels];
  }

  initForm(): void {
    this.calculateTotalDays();

    this.formModifyVehicle = this.fb.group({
      model: ['', [Validators.required]]
    });

    if (
      this.isModify &&
      this.extraData?.requestType !== this.requestTypeEnum.generalServices
    ) {
      this.formModifyVehicle
        .get('model')
        ?.setValue(this.stockVehicleData?.models[0]);
    }

    if (this.loanData?.driver.type === 'INTERNAL') {
      this.formModify = this.fb.group({
        deliveryDate: [this.loanData?.deliveryDateTime, [Validators.required]],
        returnDate: [this.loanData?.returnDateTime, [Validators.required]],
        reason: [this.loanData?.reason, [Validators.required]],
        carpoolCenter: [this.loanData?.carpoolCenter, [Validators.required]],
        reasonText: [this.loanData?.reasonObservations, [Validators.required]]
      });
    } else {
      this.formModify = this.fb.group({
        deliveryDate: [this.loanData?.deliveryDateTime, [Validators.required]],
        returnDate: [this.loanData?.returnDateTime, [Validators.required]],
        reason: [this.loanData?.reason, [Validators.required]],
        reasonText: [this.loanData?.reasonObservations, [Validators.required]]
      });
    }
  }

  openLink(type: string): void {
    if (type === 'pcc') {
      this.disableShowVehicle = false;
      window.open(this.url, '_blank');
    } else if (type === 'seat') {
      window.open(this.seatUrl, '_blank');
    } else {
      window.open(this.cupraUrl, '_blank');
    }
  }

  getValor(texto: string): number {
    if (texto.includes(',')) {
      const parsedValue = parseFloat(texto.replace(',', '.').trim());
      return parsedValue;
    }
    return parseFloat(texto.trim());
  }

  validateQuota(): boolean {
    return this.quota > this.maxQuota && this.vehicleType === 'FUNCTION';
  }

  getVehicleInformation() {
    this.spinner = true;

    this.removeData = true;
    this.quotaEmitter.emit(false);

    if (!this.form.value.vehicleCode) {
      //COMENTO HASTA VER QUE PASA AQUI
      // this.orderService.getConfiguration().subscribe({
      //   next: (res) => {
      //     this.errorPcc = false;
      //     this.vehicleInfoData = res;
      //     this.quota = this.vehicleInfoData.prices.fee
      //       ? this.getValor(this.vehicleInfoData.prices.fee)
      //       : 0;

      //     this.vehicleInfoData.country === null
      //       ? (this.vehicleInfoData.country = 'es')
      //       : (this.vehicleInfoData.country = this.vehicleInfoData.country);
      //     this.optionalCodes = this.vehicleInfoData.optionalsCodes.split(';');
      //     this.extensionCodes = this.vehicleInfoData.extensionsCodes.split(';');
      //     this.translateOptionalsAndExtensions();
      //   },
      //   error: (err: HttpErrorResponse) => {
      //     this.spinner = false;
      //     this.removeData = false;
      //     if (err.error?.detail === '5008') {
      //       this.errorPcc = true;
      //       this.errorPccText = this.controlErrors.generateError(
      //         err.error.detail,
      //         i18next.t('ErrorCode')
      //       );
      //     } else if (err.status === 404) {
      //       this.errorPcc = true;
      //       this.errorPccText = i18next.t('loadConfigError');
      //     } else {
      //       this.errorPcc = true;
      //       this.errorPccText = this.controlErrors.generateError(
      //         err.error.message,
      //         i18next.t('errorTryLater')
      //       );
      //     }
      //     this.pccErrorEmitter.emit(this.errorPcc);
      //   }
      // });
      // this.vehicleInfoVip = false;
    } else {
      this.vehiclesService
        .getConfigurationVip(this.form.value.vehicleCode)
        .subscribe({
          next: (res) => {
            this.errorPcc = false;
            this.vehicleInfoData = res;
            this.quota = !!this.vehicleInfoData.price
              ? this.vehicleInfoData.price
              : 0;
            this.spinner = false;
            this.removeData = false;
            this.vehicleInfoData.country === null
              ? (this.vehicleInfoData.country = 'es')
              : (this.vehicleInfoData.country = this.vehicleInfoData.country);
            this.quotaEmitter.emit(this.validateQuota());
            this.carConfigInfoEmitter.emit(this.vehicleInfoData);
            this.configCodeEmitter.emit(this.form.value.vehicleCode);
            this.pccErrorEmitter.emit(this.errorPcc);
            this.vehicleInfoVip = true;
          },
          error: (err: HttpErrorResponse) => {
            this.spinner = false;
            this.removeData = false;
            if (err.error?.detail === '5008') {
              this.errorPcc = true;
              this.errorPccText = this.controlErrors.generateError(
                err.error.detail,
                i18next.t('ErrorCode')
              );
            } else {
              this.errorPcc = true;
              this.errorPccText = this.controlErrors.generateError(
                err.error.message,
                i18next.t('errorTryLater')
              );
            }
            this.pccErrorEmitter.emit(this.errorPcc);
          }
        });
    }
    this.quotaEmitter.emit(this.validateQuota());
    this.showVehicleInfo.emit(this.vehicleInfoVip);
  }

  getFormattedDescriptions(): string {
    if (
      this.vehicleInfoData?.optionals &&
      this.vehicleInfoData?.optionals.length > 0
    ) {
      return this.vehicleInfoData.optionals
        .map((optional: any) => optional.description)
        .join(' / ');
    }
    return '';
  }

  getPccFormattedDescriptions(): string {
    if (
      !!this.vehicleInfoData?.descriptionOptionalCodes &&
      !!this.vehicleInfoData?.descriptionExtensionsCodes
    ) {
      this.formattedDescriptions =
        this.vehicleInfoData?.descriptionOptionalCodes
          .filter((desc) => desc !== null)
          .concat(this.vehicleInfoData?.descriptionExtensionsCodes)
          .join(' / ');
    } else {
      if (!!this.vehicleInfoData?.optionals) {
        this.formattedOptionals = this.vehicleInfoData.optionals
          .filter((optional) => optional.description !== null)
          .map((optional) => optional.description)
          .join(' / ');
      }
      if (!!this.vehicleInfoData?.extensions) {
        this.formattedDescriptions = this.vehicleInfoData.extensions
          .filter((extension) => extension.description !== null)
          .map((extension) => extension.description)
          .join(' / ');
      }
    }
    return this.formattedDescriptions + this.formattedOptionals;
  }

  changeDate(event: any, date: string) {
    const selectedDate = event.value as Date;
    const year = selectedDate.getFullYear();
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = selectedDate.getDate().toString().padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    this.formModify.get(date)?.patchValue(formattedDate);

    this.calculateTotalDays();
  }

  calculateTotalDays() {
    const deliveryDate = this.formModify.get('deliveryDate')?.value
      ? this.formModify.get('deliveryDate')?.value
      : this.loanData?.deliveryDateTime;
    const returnDate = this.formModify.get('returnDate')?.value
      ? this.formModify.get('returnDate')?.value
      : this.loanData?.returnDateTime;

    if (deliveryDate && returnDate) {
      const date1 = new Date(deliveryDate);
      const date2 = new Date(returnDate);
      const timeDifference = date2.getTime() - date1.getTime();
      this.totalDays = timeDifference / (1000 * 3600 * 24);
    } else {
      this.totalDays = 0;
    }

    this.totalQuota = this.totalDays * this.loanData?.loanQuota;
  }

  sendLoanModify() {
    let loanDataResult;
    if (this.loanData) {
      loanDataResult = {
        deliveryDate: this.formModify.get('deliveryDate')?.value,
        returnDate: this.formModify.get('returnDate')?.value,
        reason: this.formModify.get('reason')?.value,
        reasonText: this.formModify.get('reasonText')?.value,
        loanQuota: this.loanData.loanQuota ? this.loanData.loanQuota : 0,
        comments: this.extraData.comments ? this.extraData.comments : '',
        carpoolCenter: this.formModify.get('carpoolCenter')?.value,
        driverDataDTO: {
          driverType: this.loanData.driver.type,
          externalDriverData:
            this.loanData.driver.type === 'EXTERNAL'
              ? {
                  identificationDocument:
                    this.loanData.driver.externalData.identificationDocument,
                  fullName: this.loanData.driver.fullName,
                  phoneNumber: this.loanData.driver.externalData.phoneNumber,
                  email: this.loanData.driver.externalData.email
                }
              : null,
          internalDriverData:
            this.loanData.driver.type === 'INTERNAL'
              ? {
                  nis: this.loanData.driver.userId
                }
              : null,
          driverLicense: this.loanData.driver.driverLicense ? true : false,
          address: this.loanData.driver.address
            ? this.loanData.driver.address
            : null,
          zipCode: this.loanData.driver.zipCode
            ? this.loanData.driver.zipCode
            : null,
          city: this.loanData.driver.city ? this.loanData.driver.city : null
        },
        contactInfo: {
          phoneNumber: this.extraData.contactInfo.phoneNumber,
          email: this.extraData.contactInfo.email
        },
        controllerUserId: this.extraData.controller
          ? this.extraData.controller.id
          : null,
        delegatedApproverUserId: this.extraData.delegatedApprover
          ? this.extraData.delegatedApprover.id
          : null
      };

      this.orderService
        .modifyLoanOrder(loanDataResult, this.extraData.requestNumber)
        .subscribe({
          next: () => {
            this.dialog.open(FeedbackModalComponent, {
              width: '400px',
              data: {
                text: i18next.t('loanModified'),
                close: true,
                theme: 'ligth'
              }
            });
            this.getDetailEmitter.emit();
          },
          error: () => {
            this.dialog.open(FeedbackModalComponent, {
              width: '400px',
              data: {
                text: i18next.t('loanErrorModify'),
                close: true,
                theme: 'ligth'
              }
            });
          },
          complete: () => {
            console.log('Fetch complete');
          }
        });
    }
  }

  close() {
    this.deliveryPicker['_destroyOverlay']();
    this.returnPicker['_destroyOverlay']();
  }

  checkNis() {
    const nisControl = this.formModify.get('nis');
    const nis = nisControl?.value;

    if (nis && nis.length < 6) {
      nisControl?.setErrors({ invalidLength: true });
    } else if (nis && nis.length >= 6) {
      this.userService.getUserExists(nis).subscribe({
        next: (resp) => {
          if (resp) {
            nisControl?.setErrors(null);
          } else {
            nisControl?.setErrors({ userNotFound: true });
          }
        },
        error: () => {
          nisControl?.setErrors({ serverError: true });
        }
      });
    }
  }

  changeReason(reason: string) {
    if (reason === 'SUPPLIER_VISIT') {
      this.formModify.get('reasonText')?.clearValidators();
      this.formModify.get('reasonText')?.updateValueAndValidity();
    } else {
      this.formModify.get('reasonText')?.setValidators(Validators.required);
      this.formModify.get('reasonText')?.updateValueAndValidity();
    }
  }

  translateOptionalsAndExtensions() {
    Promise.all([
      firstValueFrom(this.coreService.getDescOptionals(this.optionalCodes)),
      firstValueFrom(this.coreService.getDescOptionals(this.extensionCodes))
    ]).then((descriptions: [string[], string[]]) => {
      if (!!this.vehicleInfoData) {
        this.vehicleInfoData.descriptionOptionalCodes = descriptions[0];
        this.vehicleInfoData.descriptionExtensionsCodes = descriptions[1];
      }
      this.spinner = false;
      this.removeData = false;
      this.quotaEmitter.emit(this.validateQuota());
      this.carConfigInfoEmitter.emit(this.vehicleInfoData);
      this.configCodeEmitter.emit(this.form.value.vehicleCode);
      this.pccErrorEmitter.emit(this.errorPcc);
    });
  }

  sendVehicleModify() {
    const model =
      this.formModifyVehicle.get('model')?.value !== ''
        ? this.formModifyVehicle.get('model')?.value
        : null;

    if (model) {
      this.modelListSelected.push(model);
    }

    const modelListSelect =
      this.modelListSelected.length > 0 ? this.modelListSelected : null;

    this.orderService
      .modifyVehicleModel(this.extraData.requestNumber, modelListSelect)
      .subscribe({
        next: () => {
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t('modelModify'),
              close: true,
              theme: 'ligth'
            }
          });
        },
        error: () => {
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t('modelErrorModify'),
              close: true,
              theme: 'ligth'
            }
          });
        },
        complete: () => {
          console.log('Fetch complete');
        }
      });
  }

  getModelString(models: string[]): string {
    return models.join(' - ');
  }

  setupWebSocket() {
    if (!this.isVip && !this.isDetail) {
      // Limpiar suscripción anterior si existe
      if (this.websocketSubscription) {
        this.websocketService.disconnect();
        this.websocketSubscription.unsubscribe();
      }

      this.websocketSubscription = this.websocketService
        .getMessages()
        .subscribe((msg) => {
          if (msg.split('id:')[1] === this.nis) {
            console.log(msg);
            this.websocketService.disconnect();
            this.websocketSubscription.unsubscribe();
            this.nextStep.emit();
          }
        });
      this.websocketService.connect(this.nis);
    }
  }

  reconnectWebSocket() {
    this.setupWebSocket();
  }
}
